import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PopoverController, IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'choose-size-popover',
    templateUrl: './choose-size-popover.component.html',
    styleUrls: ['./choose-size-popover.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonicModule, TranslateModule]
})
export class ChooseSizePopoverComponent implements OnInit {

  constructor(private popoverCtrl: PopoverController) { }

  ngOnInit(): void {
  }
  dismissPopover(value: number) {
    return this.popoverCtrl.dismiss(value);
  }

}
